import PostHog from "posthog-js-lite"
import { integrationDebug } from "src/integrations/lib/api"
import { posthogPublicWriteKey } from "src/integrations/posthog/constants"
import { posthogDebug } from "src/integrations/posthog/events"
import { posthogRewriteBasePath } from "src/integrations/posthog/rewrites"
import { getUserId } from "src/tracking/state"
import { runOnceInBrowser } from "src/utilities/runOnceInBrowser"

const options: ConstructorParameters<typeof PostHog>[1] = {
  // https://posthog.com/docs/libraries/js#config
  host: posthogRewriteBasePath,
  defaultOptIn: false,
  disableSurveys: true,
  preloadFeatureFlags: true,
  flushInterval: 1000,
  flushAt: 1,
  // sendFeatureFlagEvent
  // capture_pageview: false, // We handle page views manually.
  // capture_pageleave: true, // Must be enabled manually if capture_pageview is false.
  // advanced_disable_feature_flags_on_first_load: true, // Feature flags are fetched on identify.
}

export const posthogWeb = new PostHog(posthogPublicWriteKey, options)

runOnceInBrowser("posthog.init", () => {
  posthogDebug("init", options)
  posthogWeb.identify(getUserId())
  window.posthog = posthogWeb
  integrationDebug("posthog", "initialized")
})
